<h2 mat-dialog-title>Edit Image</h2>
<mat-dialog-content >
    <image-cropper
        [imageFile]="imageFile"
        [maintainAspectRatio]="true"
        [containWithinAspectRatio]="containWithinAspectRatio"
        [aspectRatio]="1 / 1"
        [resizeToWidth]="256"
        [cropperMinWidth]="128"
        [onlyScaleDown]="false"
        [roundCropper]="false"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [alignImage]="'left'"
        [style.display]="showCropper ? null : 'none'"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady($event)"
        (loadImageFailed)="loadImageFailed()">
  </image-cropper>
  </mat-dialog-content>
  <mat-dialog-actions align="center">

    <button
        mat-dialog-close
        mat-raised-button
        color="basic"
        class="mat-button-medium" >
    Cancel
  </button>
   
    <button
      mat-raised-button
      mat-dialog-close
      color="primary"
      (click)="onDone()"
      class="mat-button-medium">
      Done
    </button>
  </mat-dialog-actions>
